<template>
    <Modal
      class="create-update-modal"
      :mask-closable="false"
      :closable="false"
      :title="actionText + '代理商'"
      v-model="modal">
      <Form ref="handleForm" :model="handleForm" :rules="handleValidate" :label-width="110">
        <Row>
          <Col :sm="24" :xs="24">
            <FormItem label="代理商名称:" prop="agentId">
                <Select v-model="handleForm.agentId" clearable style="width: 100%;">
                    <Option v-for="item in commoditiesList" :value="item.id" :key="item.id">{{ item.agentName }}</Option>
                 </Select>
            </FormItem>
          </Col>
          <Col :sm="24" :xs="24">
            <FormItem label="接口地址:" prop="reqUrl">
                <Select v-model="handleForm.reqUrl" clearable style="width: 100%;">
                    <Option v-for="item in reqUrlList" :value="item.url" :key="item.url">{{ item.name }}</Option>
                 </Select>
            </FormItem>
          </Col>

        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" @click="hide" :disabled="loading">取消</Button>
        <Button type="primary" :loading="loading" @click="submit">确定</Button>
      </div>
    </Modal>
  </template>

<script>
import api from '@/api'

export default {
  name: 'AgentApiCreateUpdate',
  data () {
    return {
      modal: false,
      loading: false,
      action: 'create',
      dataIndex: null,
      commoditiesList: [], // 代理商列表
      reqUrlList: [], // 接口列表
      handleForm: {
        agentId: '',
        agentName: '',
        reqUrl: '',
        reqName: ''
      },
      handleValidate: {
        agentId: [
          { required: true, whitespace: true, message: '请选择代理商', trigger: 'change' }
        ],
        reqUrl: [
          { required: true, whitespace: true, message: '请选择接口地址', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    actionText () {
      return this.action === 'create' ? '新增' : '编辑'
    }
  },
  methods: {
    // 代理商列表
    getAgentCommoditiesList () {
      api.agent.queryAgentCommodities({}).then((res) => {
        this.commoditiesList = res.data || []
      })
    },
    // 接口列表
    getReqUrlList () {
      api.agent.getOutInterface({}).then((res) => {
        this.reqUrlList = res.data || []
      })
    },
    show (action = 'create', data = {}, index) {
      // 代理商列表
      this.getAgentCommoditiesList()
      // 接口列表
      this.getReqUrlList()
      this.action = action
      if (this.action === 'update') {
        this.handleForm = {
          agentId: data.id,
          agentName: data.agentName,
          address: data.address,
          useState: data.useState
        }
        this.dataIndex = index
      }
      this.modal = true
    },
    hide () {
      this.$refs['handleForm'].resetFields()
      this.handleForm.agentId = ''
      this.dataIndex = null
      this.loading = false
      this.modal = false
    },
    submit () {
      this.$refs['handleForm'].validate((valid) => {
        if (valid) {
          this.submitForm()
        } else {
          this.$Message.error('请填写必填项目!')
        }
      })
    },
    submitForm () {
      let queryParams = {
        ...this.handleForm
      }
      const filterData = this.commoditiesList.filter(item => item.id === queryParams.agentId)
      if (filterData && filterData.length > 0) {
        queryParams.agentName = filterData[0].agentName
      }
      const filterDataUrl = this.reqUrlList.filter(item => item.url === queryParams.reqUrl)
      if (filterDataUrl && filterDataUrl.length > 0) {
        queryParams.reqName = filterDataUrl[0].name
      }
      let submitApi = api.agent.agentPermissionsAdd
      this.loading = true
      submitApi(queryParams).then(res => {
        this.$emit('success', this.action, {
          ...queryParams
        }, this.dataIndex)
        this.$Message.success(this.actionText + '成功！')
        this.hide()
      }).catch(err => {
        this.$Message.error(this.actionText + '失败：' + err.message)
      }).then(() => {
        this.loading = false
      })
    }
  }
}
</script>
